import Config from '@/config/app.js'
import {isWechat} from '@/utils/isTerminal.js'
import {shortUrl, loginWx} from '@/api/shareH5.js'
import goodStorage from "good-storage"
import {Toast} from "vant";
import {delCurrentUrlParam} from "@/utils";

const storageKey = "userNurseLoginInfo"
export default {
  data() {
    return {
      userInfo: goodStorage.get(storageKey, null),
    }
  },
  methods:{
    getWxCodeLogin() {
      let url =  delCurrentUrlParam("code");
      shortUrl({ url }).then(r => {
          window.location.href =
            Config.wxUseUrl + "hsjmp/mp/getCode?shareKey=" + r;
      })
    },
    wxLogin(wxOkCallback,wxFailCallback){
      const { code } = window.PAGE_PARAMS;
      if (!isWechat) {
        Toast("请在微信环境使用")
        return;
      }
      if(!code){
        return
      }
      //保存code到本地，如果code被使用过了就不再使用了。
      let localCode = goodStorage.get("WXAuthCode",null);
      if (localCode && localCode === code) {
        return;
      }
      goodStorage.set("WXAuthCode",code);

      loginWx({ code, web: 1 }).then(r=>{
        if (r.loginSuccess) {
          const userInfo = r.userNurseLoginInfo;
          goodStorage.session.set("userNurseLoginInfo", userInfo);
          goodStorage.set("userNurseLoginInfo", userInfo);
          this.userInfo = userInfo;
          wxOkCallback()
        }else {
          //授权了并不是护士加用户
          wxFailCallback(r)
        }
      })
    }
  },
  created() {


  }
}
